import { INavStyleProps, INavStyles, ISearchBoxStyles } from "@fluentui/react";
import { ITheme } from "cayo.ui";
import { IElementStyles } from "../../api/schema.api";

export const navTreeWidth = 300;

export function navTreeStyle(theme: ITheme) {
  return function (navStyleProps: INavStyleProps): Partial<INavStyles> {
    return makeNavStyle(theme, navStyleProps);
  };
}

function calcLeftPadding(value?: number): number | undefined {
  if (typeof value === "undefined") {
    return value;
  }

  const basePadding = 15;
  const stepPadding = 25;

  const fluentBasePadding = 3;
  const fluentStepPadding = 14;

  if (value === fluentBasePadding) {
    return basePadding;
  }

  const steps = Math.max(1, Math.floor((value - fluentBasePadding) / fluentStepPadding));

  return basePadding + steps * stepPadding;
}

function makeNavStyle(theme: ITheme, navStyleProps: INavStyleProps): Partial<INavStyles> {
  const {
    background,
    "item-text-color": itemTextColor,
    "hover-item-background": hoverItemBackground,
    "selected-item-text-color": selectedItemTextColor,
  } = (theme.elementStyles as unknown as IElementStyles).navBar || {};

  const colors = {
    color: itemTextColor,
    background: background || theme.cayoTheme.brandColors.primaryBackground,
    highlite: hoverItemBackground,
    hoverBg: hoverItemBackground,
    selectedColor: selectedItemTextColor,
  };

  return {
    root: [
      {
        width: navTreeWidth,
        height: "100%",
        backgroundColor: colors.background,
        flexGrow: 1,
        inset: "0",
        overflowY: "auto",
        overflowX: "hidden",
      },
    ],

    link: [
      {
        color: colors.color,
        borderRadius: 0,
        selectors: {
          ".ms-Nav-compositeLink:hover &": {
            color: navStyleProps.isSelected ? colors.selectedColor : colors.color,
            backgroundColor: colors.hoverBg,
            textDecoration: "none",
          },
          ".ms-Button-icon": {
            color: `${colors.color}!important`,
            width: 20,
          },
        },
      },
      navStyleProps.isSelected && {
        color: colors.selectedColor,
        backgroundColor: colors.highlite,
        borderLeft: `3px solid ${colors.selectedColor}`,
        selectors: {
          ".ms-Nav-compositeLink:hover &": {
            backgroundColor: colors.highlite,
          },
          ":after": {
            borderLeft: "none",
          },
          ".ms-Button-icon": {
            color: `${colors.selectedColor}!important`,
          },
        },
      },
      !!navStyleProps.leftPadding && {
        paddingLeft: calcLeftPadding(navStyleProps.leftPadding),
      },
    ],
    chevronIcon: {
      color: colors.color,
    },
    chevronButton: [
      { left: `${navTreeWidth - 44}px` },
      navStyleProps.isSelected && {
        backgroundColor: colors.highlite,
        borderColor: "transparent",
        selectors: {
          ":after": { borderLeft: "none" },
        },
      },
    ],
  };
}

export const getSearchBoxStyle = (theme: ITheme): Partial<ISearchBoxStyles> => {
  const { cayoTheme, officeTheme } = theme;

  return {
    root: {
      height: 32,
      padding: "1px 0px 1px 4px",
      backgroundColor: cayoTheme.brandColors.primaryBackground,
      color: cayoTheme.brandColors.primaryBackground,
    },
    icon: {
      color: officeTheme.palette.black,
    },
    iconContainer: {
      width: 36,
    },
    clearButton: { color: "white !important" },
  };
};
